import React, {cloneElement, forwardRef, useRef} from 'react'
import {funcOrValOr} from "./CommonJS";
import {classNameScrollbarThin} from "./CommonHtml";
import {initRef, tailCheck, transitions} from "./CommonReact";
import {Button} from "./Inputs";
import {UIPopPanel} from "./UIPopPanel";


export const Menu = forwardRef(({items, dispRow, onSelect, classNameItm, itemHighlight, onPreSelect}, ref) => {
    const vals = useRef({}).current;

    function onLayout(el) {
        if (!el) return;
        vals.focusables = [...el.querySelectorAll(".dropdown-btn.cursor-pointer[tabindex]")];
        vals.focusables[0]?.focus();
        initRef(ref, el);
    }
    const moveTo = to => vals.focusables[to]?.focus();
    const move = (e, dir) => moveTo(vals.focusables.indexOf(e.target) + dir);

    return (
        <div ref={onLayout}>
            {funcOrValOr(items)?.map((itm, idx) => (
                itm.type === "sep"? <div key={idx} className="border border-bg1"/> :
                    itm.type === "static"?
                        <div key={idx} className={`flex rounded-md items-center w-full px-4 py-2 text-sm ${itm.className}`}>{itm.h}</div>
                        : <Button
                            key={idx} disabled={itm.disabled} onClick={e => (onPreSelect?.(), (itm.a || onSelect)?.(itm, idx))} {...itm.props}
                            className={tailCheck(itm.className + " " + classNameItm, "dropdown-btn", "rounded-md", "items-center gap-2",
                                "w-full", "px-3 py-1", itm.disabled ? "opacity-40 cursor-default" : "hover:bg-divider",
                                "focus-visible:bg-divider outline-none", itemHighlight === idx && "bg-prm-main/40")}
                            onKeys={{ArrowUp: e => move(e, -1), ArrowDown: e => move(e, 1),
                                Home: e => moveTo(0), End: e => moveTo(vals.focusables.length-1)}}>
                            {dispRow?.(itm, idx) ?? <>
                                {typeof itm.i !== "string"? itm.i : <span className={`${itm.i} opacity-70`}/>}
                                {itm.h}
                            </>}
                        </Button>
            ))}
        </div>
    );
});


export const PopupMenu = forwardRef(({items, dispRow, onSelect, classNameItm, itemHighlight, refMenu, header, footer, classNamePanel, ...props}, ref) =>
    <PopupPanel {...props} onShowPanel={({closePanel}) =>
        <div className={tailCheck(classNamePanel,
            classNameScrollbarThin, "bg-popup fill-subtitle1 text-title", "rounded-md",
            "overflow-auto max-h-[50vh] whitespace-pre shadow-lg ring-opacity-5 focus:outline-none"
        )}>
            {funcOrValOr(header)}
            <Menu ref={refMenu} {...{items, dispRow, classNameItm, itemHighlight, onSelect}} onPreSelect={closePanel}/>
            {funcOrValOr(footer)}
        </div>
    }/>
);


// A button popping up a panel.
//
export function PopupPanel({button, align = "bottom-start", transition = transitions.wipeDownHide, margin = 10, onShowPanel, ctrl, ...props}) {
    const rAnchor = useRef(), locCtrl = useRef({}).current;
    ctrl ||= locCtrl;

    // add onClick and ref to provided button element
    return (<>
        {button && cloneElement(button, {onClick: e => ctrl.set(cur => ({show: !cur.show})), ref: rAnchor})}
        <UIPopPanel {...{ctrl, rAnchor, align, transition, margin, ...props}} children={onShowPanel}/>
    </>);
}


export function OptsPicker({align = "bottom-start", opts, presets, button, dispPopOpt, classNamePanel}) {
    function dispOptsPanel() {
        const vOpts = typeof opts !== "function"? opts : opts();

        const dispOptsArr = opts =>
            <div className="p-1 flex items-center justify-between flex-wrap">
                {opts.map(opt => <div key={opt} className={`m-1.5`}>{dispPopOpt(opt)}</div>)}
            </div>;

        return typeof vOpts[0] !== "object"? dispOptsArr(vOpts) :
            vOpts.map(({h, v}, i) =>
                <div key={i} className="flex flex-col opacity-90">
                    <div className="px-2 pt-1 text-sm text-white">{typeof h === "string"? h + ":" : h}</div>
                    {dispOptsArr(v)}
                </div>
            );
    }

    return (
        <PopupPanel {...{button, align}} onShowPanel={() =>
            <div className={`overflow-y-auto max-h-72 whitespace-pre rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${
                (!classNamePanel?.match(/(^| )max-w-/)) && "max-w-2xl"} ${
                (!classNamePanel?.match(/(^| )bg-/)) && "bg-white dark:bg-gray-800/95 dark:text-gray-300"} ${
                classNamePanel}`}>
                {dispOptsPanel()}
            </div>
        }/>
    );
}
